namespace $ {
	export type $shm_knowledge_manual_editor_document = { id: string, content: string, revision: string }
}

namespace $.$$ {
	export class $shm_knowledge_manual_editor extends $.$shm_knowledge_manual_editor {

		@ $mol_mem
		baseline( next?: $shm_knowledge_manual_editor_document | null ) { return next ?? null }

		@ $mol_mem
		saving( next = false ) { return next }

		@ $mol_action
		load( document: $shm_knowledge_manual_editor_document ) {
			this.baseline( document )
			this.draft( document.content )
			this.error( '' )
		}

		save_enabled() { return !this.saving() && !!this.baseline() && this.draft() !== this.baseline()!.content }
		cancel_enabled() { return !this.saving() }

		@ $mol_action
		save( event?: Event ) {
			if( !event || !this.save_enabled() ) return null
			const snapshot = { ...this.baseline()!, content: this.draft() }
			this.saving( true )
			this.error( '' )
			$mol_wire_async( this ).save_request( snapshot ).then( result => {
				this.baseline( result )
				this.saved( result )
			} ).catch( error => this.error( error instanceof Error ? error.message : String( error ) ) )
				.finally( ()=> this.saving( false ) )
			return event
		}

		save_request( snapshot: $shm_knowledge_manual_editor_document ) {
			const result = this.$.$mol_fetch.json( this.api_url(), {
				method: 'POST', headers: { ...this.api_headers(), 'Content-Type': 'application/json' },
				body: JSON.stringify({ action: 'knowledge_save', kind: this.kind(), document_id: snapshot.id, content: snapshot.content, revision: snapshot.revision }),
			} ) as $shm_knowledge_manual_editor_document & { error?: string }
			if( result.error ) throw new Error( result.error )
			return result
		}

		@ $mol_action
		cancel( event?: Event ) {
			if( !event || this.saving() || !this.baseline() ) return null
			this.draft( this.baseline()!.content )
			this.error( '' )
			return event
		}
	}
}
